import { forwardRef } from 'react';
import { combineClassNames } from '../../Utils/ClassnameUtils';
import { GWPStatusSize, GWPStatusTone } from './StatusToken.types';

export interface GWPPillProps extends React.ComponentPropsWithoutRef<'span'> {
	tone?: GWPStatusTone;
	size?: GWPStatusSize;
}

const GWPPill = forwardRef<HTMLSpanElement, GWPPillProps>((props, ref) => {
	const { className, tone = 'neutral', size = 'md', children, ...rest } = props;

	const pillClassName = combineClassNames('gwp-pill', tone, size, className);

	return (
		<span ref={ref} className={pillClassName} {...rest}>
			{children}
		</span>
	);
});

GWPPill.displayName = 'GWPPill';

export default GWPPill;
